export const EPLogo = ({ variant = "white", className = "h-10" }) => (
  <img src={`/brand/ep-logo-${variant}.png`} alt="EP Group - 50 years of delivering excellence" className={`${className} w-auto`} data-testid="ep-group-logo" />
);

export const HarrodsLogo = ({ variant = "green", className = "h-8" }) => (
  <img src={`/brand/harrods-${variant}.svg`} alt="Harrods" className={`${className} w-auto`} data-testid="harrods-logo" />
);

export const CustomerBadge = () => (
  <div className="flex items-center gap-3 rounded-full border border-[#C5A059]/50 bg-[#00573F] py-1.5 pl-4 pr-5" data-testid="customer-badge">
    <span className="hidden text-[10px] font-semibold uppercase tracking-[0.18em] text-[#E6C687] sm:inline">Built for</span>
    <HarrodsLogo variant="gold" className="h-6" />
  </div>
);
